import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';


import { AjaxService } from '../../../services/ajax.service';
import { ViewScopeService } from '../../../services/view-scope.service';

import {  WORKER_INS, WORKER_UPD, WORKER_GTP, WORKERS_ROLES,WORKER_EMAIL_TKN , WORKER_UNAME_TKN} from '../../../services/account-api.constants';
import { WorkerBasicInfoCreate, WorkerBasicInfoEdit} from '../../../models/workers-general-record.model';

@Injectable(
{
	providedIn: 'root'
})

export class WorkerDialogService
{
	constructor(private ajaxService: AjaxService,
				private viewScopeService: ViewScopeService,
			) 
	{
	}

	public getSuggestedPassword()
	{
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + WORKER_GTP + this.viewScopeService.getCurrentOpertaingUserId());
	}


	public getRoles()
	{
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + WORKERS_ROLES + this.viewScopeService.getCurrentOpertaingUserId());
	}

	public getIsUserNameExsist(potentialUserName: string)
	{
		const apiUrl = `${this.ajaxService.getBaseOfApi()}${WORKER_UNAME_TKN}/${encodeURIComponent(potentialUserName)}/${this.viewScopeService.getSelectedCompanyId()}/${this.viewScopeService.getCurrentOpertaingUserId()}`;
		return this.ajaxService.getData(apiUrl).pipe(
			map((resp: any) => {
				if (Array.isArray(resp) && resp.length > 0 && resp[0].Column1 !== undefined) {
					return resp[0].Column1 === 1;
				}
				return false;
			})
		);
	}

	public getIsEmailExsist(potentialEmail: string)
	{
		const apiUrl = `${this.ajaxService.getBaseOfApi()}${WORKER_EMAIL_TKN}/${encodeURIComponent(potentialEmail)}/${this.viewScopeService.getSelectedCompanyId()}/${this.viewScopeService.getCurrentOpertaingUserId()}`;
		return this.ajaxService.getData(apiUrl).pipe(
			map((resp: any) => {
				if (Array.isArray(resp) && resp.length > 0 && resp[0].Column1 !== undefined) {
					return resp[0].Column1 === 1;
				}
				return false;
			})
		);
	}


	// actionCode: 0- create, 1 - modify
	public changesForWorker(actionCode : number, data : WorkerBasicInfoCreate|WorkerBasicInfoEdit)
	{
		console.log('RAW DATA:', JSON.stringify(data));
		
		const apiUrl = this.ajaxService.getBaseOfApi() +(actionCode === 0 ? WORKER_INS : WORKER_UPD);
		const request$ = actionCode === 0 ? this.ajaxService.addObjectData(apiUrl, data) : this.ajaxService.updateObjectData(apiUrl, data);
		
		request$.subscribe(
			{
			next: (response) => {
				if (Array.isArray(response) && response.length > 0 && response[0].RecID) 
				{
					console.log(`Saved or updated data for RecID ${response[0].RecID}.`);
				}
			},
			error: (error) => {
				console.error('Error in changesForWorker:', error);
			}
		});
	}
}